import * as _ from 'lodash';
import { IDonor, IRecipient } from '@nkr/models/index';
import { DirectedDonorsWrapper } from './styles';

interface IProps {
    recipient: IRecipient,
    list: IDonor[]
}

const DirectedDonors = (props: IProps) => {
    let { alias, hlaAvoids, bloodType, age, gender, height, weight, exportableDaysInNkr, storedPrePrefMatches, storedPostPrefMatches, storedPostPrefMatchesC, storedExportableCount, cpra4 } = props.recipient;
    let { aAvoids, bAvoids, drAvoids, bwAvoids, cwAvoids, dqAvoids, dpAvoids, dqaAvoids, avoidDr51, avoidDr52, avoidDr53 } = hlaAvoids;

    let hlaAvoidsCount =
        aAvoids.length +
        bAvoids.length +
        drAvoids.length +
        bwAvoids.length +
        cwAvoids.length +
        dqAvoids.length +
        dpAvoids.length +
        dqaAvoids.length +
        (avoidDr51 ? 1 : 0) +
        (avoidDr52 ? 1 : 0) +
        (avoidDr53 ? 1 : 0);

    let prePrefMatchPercent = _.round(storedExportableCount > 0 ? storedPrePrefMatches / storedExportableCount * 100 : 0, 1);
    let postPrefMatchPercent = _.round(storedExportableCount > 0 ? storedPostPrefMatches / storedExportableCount * 100 : 0, 1);
    let postPrefMatchPercentC = _.round(storedExportableCount > 0 ? storedPostPrefMatchesC / storedExportableCount * 100 : 0, 1);

    let donorRange = _.range(0, 6);

    let width = 82 / (donorRange.length + 1);

    return (
        <DirectedDonorsWrapper>
            <div style={{ width: '18%' }}>
                <div className='dd-header'>&nbsp;</div>
                <div className='dd-label'>Alias:</div>
                <div className='dd-label'>Antibodies:</div>
                <div className='dd-label'>Blood Type:</div>
                <div className='dd-label'>Age:</div>
                <div className='dd-label'>Gender:</div>
                <div className='dd-label'>Height (cm):</div>
                <div className='dd-label'>Weight (kg):</div>
                <div className='dd-label'>Days in NKR:</div>
                <div className='dd-label'>Pre-Pref Matches:</div>
                <div className='dd-label'>Post-Pref Matches:</div>
                <div className='dd-label'>Post-Pref VED Matches:</div>
                <div className='dd-label'># CHIPs Matched:</div>
                <div className='dd-label'>Pre-Pref Match Power:</div>
                <div className='dd-label'>Post-Pref Match Power:</div>
                <div className='dd-label'>Post-Pref VED Match Power:</div>
                <div className='dd-label'>NKR cPRA4:</div>
            </div>

            <div style={{ width: width + '%' }}>
                <div className='dd-header'>Recipient</div>
                <div className='dd-value'>{alias}</div>
                <div className='dd-value dd-antibodies'>{hlaAvoidsCount}</div>
                <div className='dd-value'>{bloodType}</div>
                <div className='dd-value dd-age'>{age}</div>
                <div className='dd-value'>{gender}</div>
                <div className='dd-value dd-height'>{height}</div>
                <div className='dd-value'>{weight}</div>
                <div className='dd-value dd-days'>{exportableDaysInNkr}</div>
                <div className='dd-value'>{storedPrePrefMatches}</div>
                <div className='dd-value dd-post-pref-matches'>{storedPostPrefMatches}</div>
                <div className='dd-value'>--</div>
                <div className='dd-value dd-chips'>--</div>
                <div className='dd-value'>{prePrefMatchPercent}%</div>
                <div className='dd-value dd-post-pref-power'>{postPrefMatchPercent}%</div>
                <div className='dd-value'>{postPrefMatchPercentC}%</div>
                <div className='dd-value dd-cpra'>{cpra4 != null ? cpra4.toFixed(2) : '--'}%</div>
            </div>

            {donorRange.map(index => {
                let donor = props.list.length > index ? props.list[index] : null;
                let donorAlias = donor != null ? donor.alias : '--';
                let donorBloodType = donor != null ? donor.bloodType : '--';
                let donorAge = donor != null ? donor.age : '--';
                let donorGender = donor != null ? donor.gender : '--';
                let donorHeight = donor != null ? donor.height : '--';
                let donorWeight = donor != null ? donor.weight : '--';
                let donorDaysInNkr = donor != null ? donor.daysInNkr : '--';
                let donorStoredPrePrefMatches = donor != null ? donor.storedPrePrefMatches : '--';
                let donorStoredPostPrefMatches = donor != null ? donor.storedPostPrefMatches : '--';
                let donorStoredChipMatches = donor != null ? donor.storedChipMatches : '--';
                let donorPostPrefMatchPower = donor != null ? _.round(donor.postPrefMatchPower, 1) + '%' : '--';

                return (
                    <div key={'dd-' + index} style={{ width: width + '%' }}>
                        <div className='dd-header'>Donor {index + 1}</div>
                        <div className='dd-value'>{donorAlias}</div>
                        <div className='dd-value dd-antibodies'>--</div>
                        <div className='dd-value'>{donorBloodType}</div>
                        <div className='dd-value dd-age'>{donorAge}</div>
                        <div className='dd-value'>{donorGender}</div>
                        <div className='dd-value dd-height'>{donorHeight}</div>
                        <div className='dd-value'>{donorWeight}</div>
                        <div className='dd-value dd-days'>{donorDaysInNkr}</div>
                        <div className='dd-value'>{donorStoredPrePrefMatches}</div>
                        <div className='dd-value dd-post-pref-matches'>{donorStoredPostPrefMatches}</div>
                        <div className='dd-value'>--</div>
                        <div className='dd-value dd-chips'>{donorStoredChipMatches}</div>
                        <div className='dd-value'>--</div>
                        <div className='dd-value dd-post-pref-power'>{donorPostPrefMatchPower}</div>
                        <div className='dd-value'>--</div>
                        <div className='dd-value dd-cpra'>--</div>
                    </div>
                );
            })}
        </DirectedDonorsWrapper>
    );
}

export default DirectedDonors;